import React from 'react';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { createQueryParamModalHelpers } from 'shared/utils/queryParamModal';
import { Modal } from 'components/shared';
import Settings from './Settings';
import Help from './Help';
import Item from './Item';
import { Container } from './Styles';
import { useStores } from 'hooks';
import { getStreamerHost } from '../../../../endpoints';
import Version from '../../../shared/Version';

const SideNavContainer = observer(
  ({
    auctionList,
    currentAuctionId,
    laneList,
    totalClientsInLane,
    totalUnitsRemaining,
    currentLaneId,
    handleAuctionChange,
    handleLaneChange,
  }) => {
    const {
      AuctionStore: { layoutSettings },
    } = useStores();

    const screens = layoutSettings;

    const handleClick = (route, layout) => window.open(`/${route}`, layout, '');

    const settingsModalHelpers = createQueryParamModalHelpers('settings-view');
    const helpModalHelpers = createQueryParamModalHelpers('help-view');
    return (
      <>
        <Container>
          <Version />
          <Item
            testid="auct-sidepanel-settings"
            onClick={settingsModalHelpers.open}
            icon="fa-cog"
            text="Settings"
          />
          {/* <Item
          onClick={helpModalHelpers.open}
          icon="fa-question-circle"
          text="Help"
        /> */}
          <Item
            onClick={() => null}
            icon="fa-motorcycle"
            text="Run List"
            testid="auct_sidepanel-runList"
            badge={totalUnitsRemaining || 0}
          />
          <Item
            key={totalClientsInLane}
            onClick={() => null}
            icon="fa-user-circle-o"
            text="Online Users"
            testid="auct_sidepanel-bidders"
            badge={totalClientsInLane || 0}
          />
          <div style={{ position: 'absolute', marginTop: 'calc(100vh - 300px)' }}>
            <Item
              data-testid="btn-streamer"
              key="sidepanel-streamer"
              icon="fa-window-restore"
              onClick={(e) => {
                e.preventDefault();
                window.open(getStreamerHost(), 'streamerWindow', '');
              }}
              text="Audio Streamer"
            />
            {screens
              ?.filter((item) => item.layoutType !== 'Bidder')
              ?.sort((a, b) =>
                a.layout < b.layout ? -1 : a.layout > b.layout ? 1 : 0,
              )
              .map(({ slug, layout, layoutID }) => (
                <Item
                  key={`launchpad-${layoutID}`}
                  testid="sidepanel-launchpad"
                  onClick={() => handleClick(slug, layout)}
                  icon="fa-window-restore"
                  text={layout
                    .replace('NPA Vehicle ', '')
                    .replace('Screen', '')}
                />
              ))}
          </div>
        </Container>

        {settingsModalHelpers.isOpen() && (
          <Modal
            isOpen
            testid="modal:settings-view"
            variant="aside"
            width={350}
            onClose={settingsModalHelpers.close}
            renderContent={() => (
              <Settings
                auctionList={auctionList}
                currentAuctionId={currentAuctionId}
                currentLaneId={currentLaneId}
                handleAuctionChange={handleAuctionChange}
                handleLaneChange={(e) => {
                  settingsModalHelpers.close();
                  handleLaneChange(e);
                }}
              />
            )}
          />
        )}

        {helpModalHelpers.isOpen() && (
          <Modal
            isOpen
            testid="modal:help-view"
            variant="aside"
            width={350}
            onClose={helpModalHelpers.close}
            renderContent={() => (
              <Help auctionList={auctionList} laneList={laneList} />
            )}
          />
        )}
      </>
    );
  },
);

SideNavContainer.propTypes = {
  auctionList: PropTypes.object,
  currentAuctionId: PropTypes.any,
  laneList: PropTypes.object,
  currentLaneId: PropTypes.any,
  handleAuctionChange: PropTypes.func.isRequired,
  handleLaneChange: PropTypes.func.isRequired,
};

SideNavContainer.defaultProps = {
  auctionList: [],
  currentAuctionId: null,
  laneList: [],
  currentLaneId: null,
};

export default SideNavContainer;
